<template>
  <div class="monitor-container">
    <el-card class="monitor-card1">
      <div class="main-header">
        <div class="main-header-left">
          <span>{{$t('CGM')}}</span>
        </div>
        <div class="main-header-right" >
          <p>{{$t('timeOfLaRead')}}&nbsp;:<span> {{sensorTime }}</span></p>
        </div>
      </div>
      <hr class="small-hr">
      <table class="status-table1">
        <tr>
          <td class="td1">{{$t('tranSn')}}:&nbsp; <label>{{sensor.serial}}</label></td>
          <td class="td1">{{$t('status')}}:<label>{{sensor.status}}</label></td>
          <td>{{$t('sensorLife')}}:<label>{{sensor.sensorLifetimeTotalCount}}</label></td>
        </tr>
        <tr>
          <td colspan="2">{{$t('lastSenorRead')}}: <label>{{getGlucose}}</label>
           <img class="sgIcon" :src="sgIcon" id="sgIcon">
          <label style="margin-left: 15px;">{{updateTime1 }}</label></td>
          <!--<td class="td2">{{$t('TranBattery')}}: <label>{{sensor.batteryPercent}}</label></td>-->
          <td class="td2">{{$t('TranBattery')}}:
              <img v-if='showCGMStatus' :src="batteryIcon" />
              <label v-else>--</label>
          </td>
        </tr>
      </table>
      <el-row>
        <el-col :span="24">
          <div id="chart1" class="graph" :element-loading-text="loadingText"  v-loading="loading"></div>
        </el-col>
      </el-row>
      <hr class="small-hr">
      <div class="legend-group" :class="{'zh1':!isEn,'es1':isEs,'de1':isDe,'it1':isIt,'po1':isPo,'du1':isDu||isFr||isCz}">
        <div class="legend"><img src="../assets/Hcp-icon/legend/Alert.png"><span>{{$t('alert')}}</span></div>
        <div class="legend"><img src="../assets/Hcp-icon/legend/target.png"><span>{{$t('target')}}</span></div>
        <div class="legend"><img src="../assets/Hcp-icon/legend/hypo.png" class="img-spe"> <span>{{$t('hypo')}}</span></div>
        <div class="legend"><img src="../assets/Hcp-icon/legend/SG.png" class="img-spe"><span>{{$t('sensorGlucose')}}</span></div>
        <div class="legend"><img src="../assets/Hcp-icon/legend/calib.png" ><span :class="{'zh4':!isEn}">{{$t('calib')}}</span></div>
        <div class="legend"><img src="../assets/Hcp-icon/legend/transmitter.png"><span>{{$t('newSen')}}</span></div>
        <div class="legend legend-spe1"  :class="{'zh2':!isEn}"><img src="../assets/Hcp-icon/legend/warm up.png"><span>{{$t('warm')}}</span></div>
      </div>
    </el-card>


    <el-card class="monitor-card2">
      <div class="main-header">
        <div class="main-header-left">
          <span>{{$t('InsulinPump')}} </span><!--<button @click="testButton">test button</button>-->
        </div>
        <div class="main-header-right" >
          <p>{{$t('timeOfLaPump')}} :&nbsp;<span> {{pumpTime}}</span></p>
        </div>
      </div>
      <hr class="small-hr">
      <table class="status-table1 status-table2">
        <tr>
          <td class="td1">{{$t('pumpSN')}}: <label>{{pump.serial}}</label></td>
          <td class="td1">{{$t('status')}}:<label>{{pump.state}}</label></td>
          <td class="td3">{{$t('ReserviorLife')}}: <label>{{pump.remainingTime}}</label></td>
        </tr>
        <tr>
          <td class="td1">{{$t('InsulinLeft')}}: <label>{{pump.remainingDose}}</label></td>
          <td class="td1">{{$t('basal')}}:<label>{{pump.basalRate}} </label></td>
          <td>{{$t('totalBasal')}}:<label>{{pump.basalSum}}</label></td>
        </tr>
        <tr>
          <td>{{$t('lastBolus')}}:<label>{{lastBolus}}</label></td>
          <td class="td4">{{$t('activeInsulin')}}:<label>{{pump.iob}}</label></td>
          <td class="td2">{{$t('totalBolus')}}:<label>{{pump.bolusSum}} </label></td>
        </tr>
      </table>
      <el-row>
        <el-col :span="24">
          <div id="chart2"></div>
        </el-col>
      </el-row>
      <hr class="small-hr">
      <div class="legend-group card2-legend" :class="{'zh3':!isEn,'es3':isEs,'de3':isDe,'it2':isIt,'po2':isPo,'du2':isDu||isFr||isCz,'sw2':isSw}">
        <div class="legend"><img src="../assets/Hcp-icon/legend/Alert.png"><span>{{$t('alert')}}</span></div>
        <div class="legend"><img src="../assets/Hcp-icon/legend/basal.png"><span>{{$t('basal')}}</span></div>
        <div class="legend"><img src="../assets/Hcp-icon/legend/temp basal.png"> <span>{{$t('tampBasal')}}</span></div>
        <div class="legend "><img src="../assets/Hcp-icon/legend/normal bolus.png"><span>{{$t('normalBolus')}}</span></div>
        <div class="legend "><img src="../assets/Hcp-icon/legend/extend bolus.png"><span>{{$t('extendBolus')}}</span></div>
        <div class="legend "><img src="../assets/Hcp-icon/legend/auto suspend.png"><span class="span1">{{$t('manualStop')}}</span></div>
        <div class="legend sep-1"><img src="../assets/Hcp-icon/legend/patch Deactivated.png"><span>{{$t('stop')}}</span></div>
        <div class="legend sep-2"><img src="../assets/Hcp-icon/legend/new Patch.png"> <span>{{$t('newPatch')}}</span></div>
        <div class="legend spe"><img src="../assets/Hcp-icon/legend/Auto Suspend 2.png"><span class="span1">{{$t('autoStop')}}</span></div>

        <div class="legend"><img src="../assets/Hcp-icon/legend/automode/icon_histogram.png"><span>{{$t('t1222_auto_basal')}}</span></div>
        <div class="legend"><img src="../assets/Hcp-icon/legend/automode/auto_bolus.png"><span>{{$t('t1222_auto_bolus')}}</span></div>

      </div>
    </el-card>

    <!--时间选择对话框-->
    <el-dialog  :visible.sync="showConfirmDialog" :size=dialogSize  id="dialog-form2"
                :show-close="false" :close-on-click-modal="false">
      <div class="dialog-title">
        <p>{{$t('privacy_policy_and_terms_of_use')}}</p>
      </div>

      <div class="dialog-content">
        <!--<p>我们最近更新了
          <a href="https://www.medtrum.com/privacy_pilicy.html" target="_blank">隐私政策</a>和
          <a href="https://www.medtrum.com/terms_of_use.html" target="_blank">服务协定</a>。请仔细阅读，同意并接受全部条款后再使用EasyView</p>
      -->
        <p v-html="$t('privacy_confirm_text')" id="privacy_confirm_text"></p>
        <!--<p id="privacy_confirm_text_2">qwe</p>-->
      </div>

      <div class="dialog-footer">
        <button @click="denyPrivacyConfirm" class="deny">{{$t('privacy_confirm_disagree')}}</button>
        <button @click="agreePrivacyConfirm" class="agree">{{$t('privacy_confirm_accept')}}</button>
        <div style="clear: both;"></div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import Vue from 'vue'
  import * as echarts from 'echarts'
  import auth from '../auth/auth'
  import B64 from '../auth/base64'
  import {loading} from './mixins/loading'
  import format from '@/lib/format'
  import formatClass from '@/lib/chartTipFormat';
  export default{
    mixins: [loading],
    data(){
      return{
          chartWidth: '', timer: false, st:0,et:0,clock:'',updateTime1:'',sgIcon:'',batteryIcon:'',uid:0,isMg:'',st1:'',DataSG:[],ts:[],isEs:false,
          sensor_alarm:[], pump_alarm:[],carb:[],exercise:[],calib:[],lastBolus:'--',isDe:false,isIt:false,isPo:false,isDu:false,
          extend_bolus:[[10,10,10,10,10]],basal_suspend:[],newBasal:[],stopBasal:[],basal_suspend2:[],isFr:false,isSw:false,isCz:false,
          sgMax:25,basalMax:5,bolusMax:10,DataBolus:[],tempBasal:[],sensorTime:'--',pumpTime:'',updateXhr:null,
          sleepTime1:[[10,10,10],[10,10,10]],
          sleepTime2:[[10,10,10],[10,10,10]],

          autoModeBasal:[],
          autoModeCorrBolus:[],

          showConfirmDialog:false,
          dialogSize:'small',
          bolus:[],
          basal:[],
          chartColumn: null, chartColumn1: null, isEn:false,tz:8,timeout2:'',
          textStyle: {
            color: '#282828',
            fontWeight: 'normal',
            fontSize: '14',
            fontFamily: 'SFUIText-Regular'
          },
          titlePadding: [0, 0, 8, 33],
          grid: {x: '3%', y: '16%', width: '94%', height: '73%'},
          sgRange: [['', '4.4', '8.9', '13.3', '17.8', '22.2'], ['', '0.2', '0.4', '0.6', '0.8', '1.0']
            , ['', '1', '2', '3', '4', '5'], ['0', '1', '2', '3', '4', '5'], ['', this.$t('Light'), '', this.$t('Medium'), '', this.$t('heavy')]],
          dateTime: ["00:00", " ", "", "3:00", "", "", "6:00", "", "", "9:00", "", "", "12:00", "", "", "15:00", "",
            "", "18:00", "", "", "21:00", "", "", "24:00",],
          yAxisLabel: {interval: 0, margin: 5, textStyle: {color: '#282828', baseline: 'middle'}, showMinLabel: false},
          areaStyle: {
            color: ['rgba(200,200,200,0.3)', 'rgba(200,200,200,0.3)', 'rgba(200,200,200,0.3)', 'rgba(200,200,200,0.3)', 'rgba(200,200,200,0.3)',
              'rgba(200,200,200,0.3)', 'rgba(200,200,200,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)',
              'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)',
              'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)', 'rgba(250,250,250,0.3)']
          },
          status:['--',this.$t('Warm up'),this.$t('Warm up'),this.$t('Monitoring'),this.$t('Transmitter Error'), this.$t('Sensor Failure'),
            this.$t('Sensor Expired'), this.$t('Lost Sensor'), this.$t('Not Calibrated'), this.$t('Calibrating'),this.$t('Calibration Needed'),
            this.$t('Calibration Error'), this.$t('Calibration Error'),this.$t('Charging Battery'), this.$t('Battery Charged'),
          ],
          state1:['--',this.$t('To be filled'),this.$t('Filled with insulin'),this.$t('Priming'), this.$t('Priming completed'),this.$t('Inserting needle'),this.$t('Patch activated')],
          state2:[this.$t('Delivering Basal'),this.$t('Delivering Basal')],
          state3:[ this.$t('Low Suspend'),this.$t('Predictive Low Suspend'),this.$t('Auto Off'),this.$t('Exceeds Max 1 Hour Delivery'),this.$t('Exceeds Max TDD'),this.$t('Suspend')],
          state4:[this.$t('Occlusion Detected'),this.$t('Patch Expired'),this.$t('Empty Reservoir'),this.$t('Patch Error'),this.$t('Patch Error'),
            this.$t('Pump Base Error'),this.$t('Patch Battery Depleted'),this.$t('Magnetic sensor not calibrated')],
          injState:{
            'BART':this.$t('Delivering Temp Basal'),
            'Bolus':this.$t('Delivering Bolus')
          },
          showCGMStatus:false,
          basalChartUpdateTime:0,
          bolusChartUpdateTime:0,
          //privacy_confirm_text:'We'
      }
    },

    computed: {
      sensor(){
        return this.$store.state.sensor;
      },
      pump(){
        return this.$store.state.pump;
      },
      DataS(){
        return this.$store.state.DataS;
      },
      DataBasal(){
        return this.$store.state.DataBasal;
      },
      timeout1:{
          set(val){
            this.$store.state.compileTimeout = val;
          },
          get(){
            return this.$store.state.compileTimeout;
          }
      },
      getGlucose () {
      if (this.sensor.glucose && this.sensor.glucose !== '--') {
        let range = this.isMg === true ? [40, 400] : [2.2, 22.2]
        let num = +this.sensor.glucose.match(/[0-9\\.]+/g)[0]
        if (num > range[1]) return 'HIGH'
        else if (num < range[0]) return 'LOW'
        else return this.sensor.glucose
      }
      return this.sensor.glucose
    }
    },
    methods: {
      addBasalRecord(newBasal){
        var curDate=new Date();
        var curDateStart=new Date(curDate.getFullYear(), curDate.getMonth(), curDate.getDate());
        var curDateStart = curDateStart.getTime() / 1000;
        if ((newBasal[1]+newBasal[3]) <= curDateStart || newBasal[1] >= (curDateStart+86400)) {
          return false;
        }

        var i=0;
        for (; i<this.basal.length; i++) {
          // 判断id是否相同
          if (newBasal[0]==this.basal[i][0]) {
            this.basal[i]=newBasal;
            return true;
          }
        }
        if (i==this.basal.length) {
          this.basal.push(newBasal);
          //this.basal.sort(function (v1, v2){
          //  return v1[1]>v2[1];
          //})
          return true;
        }
        return false;
      },
      addBolusRecord(newBolus){
        var curDate=new Date();
        var curDateStart=new Date(curDate.getFullYear(), curDate.getMonth(), curDate.getDate());
        var curDateStart = curDateStart.getTime() / 1000;
        if (newBolus[1] < curDateStart || newBolus[1] >= (curDateStart+86400)) {
          return false;
        }

        var i=0;
        for (; i<this.bolus.length; i++) {
          // 判断id是否相同
          if (newBolus[0]==this.bolus[i][0]) {
            this.bolus[i]=newBolus;
            return true;
          }
        }
        if (i==this.bolus.length) {
            this.bolus.push(newBolus);
            return true;
        }
        return false;
      },
      // todo: 需要考虑到时间超出的情况处理。先排序， 首尾时间处理。
      calDayBasalTotal() {
        let basalTotal=0;
        for (let i=0; i<this.basal.length; i++) {
          // 自动模式的记录不在这里统计
          if ('BAAM' != this.basal[i][2]) {
            basalTotal += this.basal[i][5];
          }

        }
        return basalTotal;
      },
      calDayAutoModeTotal () {
        let autoBasalTotal=0;
        let autoBolusTotal=0;
        for (let i=0; i<this.basal.length; i++) {
          let basalType = this.basal[i][2];
          if ('BAAM'==basalType) {
            let autoModeData=this.basal[i][7];
            //let autoModeData = basalRecord[7];
            try {
              autoModeData=JSON.parse(autoModeData);
              let autoModeJson=autoModeData['autoModeJSON'];
              autoModeJson.map(function(e, i){
                autoBasalTotal += e['auto_basal_delivery']*0.05;
                autoBolusTotal += (e['auto_food_delivery'] + e['auto_corr_delivery'])*0.05;
              })
            } catch (e) {
              console.log('calDayAutoModeTotal error:', e)
            }
          }
        }
        return [autoBasalTotal, autoBolusTotal];
      },
      // todo: 需要考虑到时间超出的情况处理。先排序， 首尾时间处理。
      calDayBolusTotal() {
        let bolusTotal=0;
        for (let i=0; i<this.bolus.length; i++) {
          bolusTotal += this.bolus[i][4]+this.bolus[i][6];
        }
        return bolusTotal;
      },

      drawColumnChart() {
        let id = 'chart1'
        let that = this;
        this.chart1= echarts.init(document.getElementById(id));
        this.registLoading(id,this.chart1)
        this.chart1.setOption({
          title: {
            text:(this.isMg)? this.$t('SG')+' (mg/dL)':this.$t('SG')+' (mmol/L)',
            textStyle: this.textStyle,
            padding: this.titlePadding,
          },
          tooltip:{
            trigger:'axis',
            axisPointer:{
              type:'line',
              axis:'x',
              lineStyle:{color:'#333',}
            },
            backgroundColor:'#555',
            textStyle:{
              color: ' #ffffff',
            },
            formatter:function(params){
              let tip = format.formatterTip1(params,that);
              //console.log('monitor tip:', tip);
              return tip ;
            },
          },
          xAxis: [{
            type: 'time',
            boundaryGap: false,
            min:this.st*1000,
            max:this.et*1000,
            axisLabel:{
              showMaxLabel: true,
              margin: 10, textStyle: {color: '#282828', baseline: 'middle'} ,
              formatter:function (value,index) {
                // let H = new Date(value).getHours();
                index=(value-that.st*1000)/3600000;
                let H=index;
                if(index<24){
                  if(index%3===0){
                    H = H<10 ? ('0'+H+':00' ): H+':00';
                    return  H;
                  }else{
                    return ' ';
                  }
                }else{
                    return '24:00';
                }
              }
            },
            axisLine: {lineStyle: {color: '#ccc'}},
            splitNumber: 24,
            axisPointer:{snap:true}
          }],
          yAxis: [
            {
              type: 'value',
              min:0,
              max:this.sgMax,
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
              boundaryGap: false,
              axisTick: {length: 0},
            }],
          grid: this.grid,
          series: [
            {
              name:'SG',
              type: 'scatter',
              data: this.DataSG,
              itemStyle: {normal: {
                color:function (params) {
                  let color = '#2cd200';
                  if(params.value[1]<0.1&&params.value[2]==='H'){
                    color = '#a4a4a4';
                  }
                  else{
                    if(that.isMg){
                      if(params.value[1]>that.DataS.blos_high*18){color = '#e6be00'}
                      if(params.value[1]<that.DataS.blos_low*18){color = '#ff5c5c'}
                    }else{
                      if(params.value[1]>that.DataS.blos_high){color = '#e6be00'}
                      if(params.value[1]<that.DataS.blos_low){color = '#ff5c5c'}
                    }
                  }
                  let type = params.value[2];
                  if((type==='NC'&&params.value[1]==0)||type==='DE'||type==='CE0'||type==='CE1'){
                    color = 'transparent';
                  }
                  return color;
                }
              }},
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  if(params.value[1]>0){
                    //console.log("monitor sg tooltip:");
                    if(params.value[2]==='CX'||params.value[2]==='NC'){
                      return  time[0]+':'+time[1]+', '+params.value[1]+
                        '<hr style="width: 20px;background:#fff;height:1px;border:none;margin-left: 42px;">';
                    }
                    return  time[0]+':'+time[1]+', '+params.value[1];
                  }
                  else{
                    if(params.value[2]==='NC'){
                      return time[0]+':'+time[1]+', Not Calibrated';
                    }
                    if(params.value[2]==='DE'){
                      return time[0]+':'+time[1]+', No Readings';
                    }
                    if(params.value[2]==='CE0'||params.value[2]==='CE1'){
                      return time[0]+':'+time[1]+',Calib Error';
                    }
                    return time[0]+':'+time[1]+', warm up';
                  }
                },
              },
              markArea: {
              data: [
                [{yAxis: (this.isMg)?this.DataS.blos_low*18:this.DataS.blos_low}, {yAxis:(this.isMg)?this.DataS.blos_high*18:this.DataS.blos_high}]
                ],
               tooltip:{show:false,
               trigger:'none'},
               itemStyle: {
                 normal: {
                   color: 'rgba(211,255,213,0.6)',
                 }
                }
              },
              markLine: {
               data: [{ yAxis:(this.isMg)?this.DataS.hypo*18:this.DataS.hypo}],
                silent:true,
               symbol:['circle','circle'],
               symbolSize: 1,
               lineStyle: {normal: {
                color: 'rgba(255,0,0,0.5)',
                type: 'solid',
               }},
              label:{normal:{show:false}},
              },
              symbolSize:2,
            },
            {
              type: 'scatter',
              data: this.calib,
              name: 'calib',
              symbol:'image://static/legend/calib.png',
              tooltip:{backgroundColor:'#555',
              trigger:'item',
                formatter:(params)=>{
                  const timeDetail = formatClass.getFormatterTip1TimeDetail(params.value[0]);
                  const tip = timeDetail + formatClass.calibFormat(params, this);
                  return  tip;
                },
              },
              label:{
              show: this.$store.state.glucose_display==='On',
              color: '#114C9A',
              backgroundColor:'#E7F5F9',
              position: 'top',
              distance:10,
              fontSize:16,
              width:40,
              height:20,
              borderColor:'#7AACBF',
              },
              emphasis: {
                focus: 'self'
              },
            },
            {
              type: 'scatter',
              name:'alarm',
              data: this.sensor_alarm,
              symbol:'image://static/legend/Alert.png',
              symbolSize:13,
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  //console.log(time)
                  return  time[0]+':'+time[1]+', '+params.value[2];
                },
              },
            },
            {
              type: 'scatter',
              name:'transmtr',
              data: this.transmtr,
              symbol:'rect',
              symbolSize:5,
              itemStyle: {normal: {color: '#00a107'}},
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', '+'New Sensor';
                },
              },
            },
            {
              type: 'custom',
              data:this.sleepTime1,
              z:-1,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              tooltip:{show:false,},
              itemStyle:{normal: {color: 'rgba(170,170,170,0.2)'}},
            },
          ],
        });
      },
      drawColumnChart1() {
        let id = 'chart2'
        let ins_unit2=this.$t('ins_unit2');
        let that=this;
        this.chart2 = echarts.init(document.getElementById(id));
        this.chart2.setOption({
          title: [
            {
            text: this.$t('basal')+' '+this.$t('basal_unit'),
            textStyle: this.textStyle,
            padding: this.titlePadding,
          }, {
            text: this.$t('bolus')+' '+this.$t('ins_unit'),
            textStyle: this.textStyle,
            right: '18',
          },
          ],
          tooltip:{
            trigger:'axis',
            axisPointer:{
              type:'line',
              axis:'x',
              lineStyle:{color:'#333',}
            },
            backgroundColor:'#555',
            textStyle:{
              color: ' #ffffff',
            },
            formatter:function(params){
              let tip = format.formatterTip(params, that, 'monitor');
              return tip ;
            },
          },
          xAxis: [{
            type: 'time',
            boundaryGap: false,
            min:this.st*1000,
            max:this.et*1000,
            interlval:0,
            // data:['A','B'],
            axisLabel:{
              showMaxLabel: true,
              margin: 10, textStyle: {color: '#282828', baseline: 'middle'} ,
              formatter:function (value,index) {
                // console.log('time axis:', value, index)
                // if (0==index)
                //   return '';

                // index = index-1
                // let H = new Date(value).getHours();
                index=(value-that.st*1000)/3600000;
                let H=index;
                // console.log('time axis:', value, index)
                if(index<24){
                  if(index%3===0){
                    H = H<10 ? ('0'+H+':00' ): H+':00';
                    return  H;
                  }else{
                    return ' ';
                  }
                }else{
                  // console.log('time axis 24H');
                  return '24:00';
                }
              }
            },
            axisLine: {lineStyle: {color: '#ccc'}},
            splitNumber: 24,
          }],
          yAxis: [
            {
            type:'value',
            boundaryGap: false,
            min:0,
            max:this.basalMax,
            axisTick: {length: 0},
            axisLabel: this.yAxisLabel,
            axisLine: {lineStyle: {color: '#ccc'}},
          },
            {
/*
            data: this.sgRange[3],
            boundaryGap: false,
            axisTick: {length: 0},
            axisLabel: this.yAxisLabel,
            axisLine: {lineStyle: {color: '#ccc'}},
              splitLine:{show:false,},*/

              type:'value',
              boundaryGap: false,
              min:0,
              max:this.bolusMax,
              axisTick: {length: 0},
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
              splitLine:{show:false,},
          }
          ],
          grid: this.grid,
          series: [
            {
              type: 'line',
              name:this.$t('basal'),
              data:this.DataBasal,
              // step:'middle',
              itemStyle: {normal: {color: '#00ff40'}},
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', '+params.value[1];
                },
              },
              symbolSize:2,
            },
            {
              type: 'line',
              name:this.$t('auto suspend'),
              data:this.basal_suspend,
              itemStyle: {normal: {color: '#ff0000'}},
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', '+params.value[2];
                },
              },
              lineStyle:{normal:{type:'dashed'}},
              symbolSize:1,
            },
            {
              type: 'line',
              name:this.$t('tempBasal'),
              data:this.tempBasal,
              itemStyle: {normal: {color:  '#00ff40'}},
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', '+'TempBasal: '+params.value[1];
                },
              },
              lineStyle:{normal:{type:'dashed'}},
              symbolSize:1,
            },
            {
              type: 'line',
              name:this.$t('manualStop'),
              data:this.basal_suspend2,
              itemStyle: {normal: {color: '#ff0000'}},
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', '+'Manual Suspend';
                },
              },
              symbolSize:1,
            },
            {
              type: 'custom',
              name:this.$t('normalBolus'),
              //data:[[new Date(), 3.4, 'N']],
              data:this.DataBolus,
              z:999,
              yAxisIndex:1,
              itemStyle: {normal: {color: '#182f82'}},
               renderItem: function (params, api) {
                  let y = api.value(1);
                  let start = api.coord([api.value(0),y]);
                  let size = api.size([600000,y]);
                  let style = api.style()
                  // if(auth.showSuggest(api.value(1),api.value(3))){
                  //   style.fill = 'red'
                  // }
                  return {
                    type:'rect',
                    shape:{
                      x: start[0],
                      y: start[1],
                      width:size[0],
                      height:size[1],
                    },
                    style:style,
                  }
                },
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return time[0]+':'+time[1]+', '+params.value[2]+': '+params.value[1]+ins_unit2;
                },
              },
              barWidth:'4',
            },
            {
              type: 'custom',
              name:this.$t('extendBolus'),
              data:this.extend_bolus,
              yAxisIndex:1,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width: size[0],
                    height: size[1],
                  },
                  style:style,
                }
              },
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return time[0]+':'+time[1]+', '+params.value[4]+': '+params.value[2]+ins_unit2+'/'+params.value[3]+'min';
                },
              },
              itemStyle:{normal: {color: '#f9b4ff'},emphasis:{color: '#f9b4ff'}},
            },
            {
              type: 'scatter',
              name:this.$t('newPatch'),
              data:this.newBasal,
              itemStyle: {normal: {color:'#fff',borderColor: '#f00'}},
              symbol:'image://static/legend/new%20Patch.png',
              symbolSize:10,
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+',New Patch ';
                },
              },
            },
            {
              type: 'scatter',
              name:this.$t('stop'),
              data:this.stopBasal,
              symbol:'image://static/legend/patch%20Deactivated.png',
              symbolSize:8,
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', Delivery Stop';
                },
              },
            },
            {
              type: 'scatter',
              name:this.$t('alert'),
              data: this.pump_alarm,
              symbol:'image://static/legend/Alert.png',
              symbolSize:13,
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', '+params.value[2];
                },
              },
            },
            {
              type: 'custom',
              data:this.sleepTime2,
              z:-1,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              tooltip:{show:false,},
              itemStyle:{normal: {color: 'rgba(170,170,170,0.2)'}},
            },
            {
              type: 'custom',
              name:this.$t('t1222_autoModeBasal'),
              data:this.autoModeBasal,
              yAxisIndex:0,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:{
                      fill:'rgba(0, 255, 76, 0.5)',
                  }
                }
              },
              tooltip:{backgroundColor:'#333',
                // formatter:function(params){
                //   let date = params.value[0];
                //   let time = format.formatterDate5(date);
                //   return time[0]+':'+time[1]+', '+params.value[4]+': '+params.value[2]+ins_unit2+'/'+params.value[3]+'min';
                // },
              },
              itemStyle:{normal: {color: '#00ff4c'},emphasis:{color: '#00ff5c'}},
            },
            {
              type: 'custom',
              name:this.$t('t1222_autoModeCorrBolus'),             // index 11
              data:this.autoModeCorrBolus,
              yAxisIndex:1,
              itemStyle: {normal: {color: '#009bff'}},
              renderItem:function (params,api) {
                  let y = api.value(2) + api.value(1);
                  let start = api.coord([api.value(0),y]);
                  let size = api.size([600000,y]);
                  let style = api.style();
                  return {
                    type:'rect',
                    shape:{
                      x: start[0],
                      y: start[1],
                      width:size[0],
                      height:size[1],
                    },
                    style:style,
                  }
                },
              barWidth:'4',
            },
          ]
        });
      },

      drawCharts() {
      //console.log({tz: JSON.stringify(this.tz), uid: JSON.stringify(this.uid), transmtr: JSON.stringify(this.transmtr), DataSG: JSON.stringify(this.DataSG), st: JSON.stringify(this.st), et: JSON.stringify(this.et), basal: JSON.stringify(this.basal), bolus: JSON.stringify(this.bolus), sensorTime: JSON.stringify(this.sensorTime), pumpTime: JSON.stringify(this.pumpTime), basalMax: JSON.stringify(this.basalMax), newBasal: JSON.stringify(this.newBasal), stopBasal: JSON.stringify(this.stopBasal), autoModeBasal: JSON.stringify(this.autoModeBasal), autoModeCorrBolus: JSON.stringify(this.autoModeCorrBolus), basal_suspend: JSON.stringify(this.basal_suspend), tempBasal: JSON.stringify(this.tempBasal), basal_suspend2: JSON.stringify(this.basal_suspend2), DataBasal: JSON.stringify(this.DataBasal), DataBolus: JSON.stringify(this.DataBolus), extend_bolus: JSON.stringify(this.extend_bolus), bolusMax: JSON.stringify(this.bolusMax), sensor_alarm: JSON.stringify(this.sensor_alarm), pump_alarm: JSON.stringify(this.pump_alarm), calib: JSON.stringify(this.calib), showCGMStatus: JSON.stringify(this.showCGMStatus)});
        this.drawColumnChart();
        this.drawColumnChart1();
      },
      handleResize(){
        let win = window.innerWidth;
        let scale = (win<1500)?0.91:0.62;
        const chartWidth = win * scale * 0.98 * 0.95 + 'px';
        let chart1 = document.getElementById('chart1');
        let chart2 = document.getElementById('chart2');
        if(chart1){
          chart1.style.width = chartWidth;
          chart2.style.width = chartWidth;
        }
      },
      reFresh(){
          let uid = [this.uid];
          let param ={
              uids:uid,
          };
          sessionStorage.setItem('monitor',1);
          auth.getMonData1(this,param);
      },
      checkPrivacyVersion() {
        this.$http.get('/api/v2.1/user/privacy/confirm').then(function(res){
          if (0==res.data.error) {
            if (0==res.data.confirm) {
              this.showConfirmDialog=true;
              //
              //let strHtml=this.$t('')
              //let ele=document.getElementById('privacy_confirm_text_2');
              //let strHtml=ele.innerHTML;
              //console.log('strHtml:', strHtml);
            }
          }
        }, function(err){

        })
      },
      denyPrivacyConfirm(){
        this.showConfirmDialog=false;
      },
      agreePrivacyConfirm(){
        this.showConfirmDialog=false;
        this.$http.post('/api/v2.1/user/privacy/confirm').then(function (res) {
        },function (err) {

        })
      },
      testButton(){
        //this.bolus.splice(this.bolus.length-1, 1);
        //auth.updateBolusChart(this);

        //this.basal.splice(this.basal.length-1, 1);
        auth.updateBasalChart(this);
      }
    },
    created(){
     /* Vue.http.interceptors.push((request, next) => {
        if(request.url === 'api/v2.0/monitor/data'){
          //console.log(request);
          console.log(this);
          this.$store.commit('updateRequest',request);
        }
        next((response) => {
          return response;
        });
      });*/
      if(this.timeout1){
        clearTimeout(this.timeout1);
      }
    },
    beforeDestroy(){
      let request = this.$store.state.Request;
      if(request.length>0){
          request.map(function (e,i) {
            e.abort();
          });
      }
      this.$store.commit('updateRequest',null);
      sessionStorage.removeItem('monitor');
      if(this.timeout1){
        clearTimeout(this.timeout1);
      }
    },

    mounted: function () {
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isEs = (lang==='es')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isSw = (lang==='sw')?true:false;
      this.isCz = (lang==='cz')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.sgMax = (this.isMg)? 400:25;
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      this.st1= new Date().setHours(0,0,0,0)/1000;
      let sta = format.formatterDate9(this.st1);
      let starDate = new Date(this.st1*1000);
      let et = new Date(starDate.setDate(sta[2]+1)).getTime()/1000;
      this.ts = [this.st1,et];
      this.tz =parseInt( sessionStorage.getItem('tz'));
      let param = {
        ts:this.ts,
        tz:this.tz
      };
      param = B64.base64encode(JSON.stringify(param));
      auth.getMonData(this,param,this.uid);
      this.checkPrivacyVersion();
      let that = this;
      window.onresize = function () {
        that.handleResize();
        that.chart1.resize();
        that.chart2.resize();
      }
      this.reFresh();
      //

    },
  }
</script>

<style scoped>
  .monitor-container{
    height:100%;
    width:100%;
    background:#fafbfc;
    font-size: 18px;
    color:#282828;
    letter-spacing:-0.44px;
    font-family:SFUIText-Regular;
    padding-top: 20px;
  }
  .monitor-card1,.monitor-card2{
    width: 97%;
    margin: 0 auto;
  }
  .monitor-card1{
    margin-bottom: 18px;
  }
  .main-header{
    width:97%;
    height:40px;
    margin:0 auto;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    margin-top:10px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .main-header-right{
    float: right;
    height:30px;
    line-height: 30px;
    margin-right: 1%;
  }
  .main-header-right p{
    float:right;
    margin-top:2px;
  }
  .main-header-right span{
    color:#0082d2;
  }
  .small-hr{
    background:#e6e8ea;
    width:97%;
    height:1px;
    margin:10px auto 20px;
    border:none;
  }
  .status-table1{
    width: 95%;
    height:70px;
    margin:0 auto;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
  }
  .status-table1 td{
    padding-left: 10px;
  }
  .status-table1 .td1{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td2{
     border-top:1px solid rgba(116,116,116,0.34);
     border-left:1px solid rgba(116,116,116,0.34);
   }
  .status-table1 .td3{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td4{
    border-left:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 td label{
    color:#0082d2;
    margin-left: 5px;
  }
  .status-table2{
    height:105px;
    text-align: center;
  }
  .status-table2 td{
    padding: 0;
  }

  #chart1,#chart2{
    width:100%;
    height:170px;
    margin-bottom: 30px;
    margin-top:20px;
  }
  .legend-group{
    width:94%;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:left;
  }
  .legend{
    float:left;
    margin-bottom: 25px;
    margin-right:65px;
    height:20px;
    line-height: 20px;
  }
  .card2-legend .legend{
    margin-right: 65px;
  }
  .card2-legend .sep-1{
    margin-right: 26px;
  }
  .card2-legend .sep-2{
    margin-right: 44px;
  }
  .card2-legend .span1{
    margin-bottom: 2px;
    display: block;
    float: right ;
  }
  .legend img{
    margin-right: 8px;
  }
  .legend-spe1{
    margin-right: 5px;
  }
  .img-spe{
    margin-bottom: 4px;
  }
  .sgIcon{
    margin-left: 20px;
    margin-bottom: -4px;
  }
  .zh1 div{
    margin-right: 70px;
  }
  .zh1 .zh2{
    margin-right: 0;
  }
  .es1 div{
    margin-right: 30px;
  }
  .de1 .legend{
    margin-right: 40px;
  }
  .es1 .legend-spe1{
    margin-right: 0;
  }
  .zh3 .legend{
    margin-right: 25px;
  }
  .es3 .legend{
    margin-right: 50px;
  }
  .es3 .sep-1{
    margin-right: 95px;
  }
  .es3 .sep-2{
    margin-right: 42px;
  }
  .de3 .legend{
    margin-right: 40px;
  }
  .de3 .sep-1{
    margin-right: 55px;
  }
  .it1 .legend{
    margin-right: 40px;
  }
  .it2 .legend{
    margin-right: 50px;
  }
  .it2 .sep-1{
    margin-right: 62px;
  }
  .po1 .legend{
    margin-right: 40px;
  }
  .po1 .legend-spe1{
   margin-right: 0;
  }
  .po2 .legend{
    margin-right: 40px;
  }

  .du1 .legend{
    margin-right: 40px;
  }
  .du1 .legend-spe1{
    margin-right: 0;
  }
  .du2 .legend{
    margin-right: 40px;
  }
  .sw2 .sep-1{
    margin-right: 35px;
  }
  .sw2 .sep-2{
    margin-right: 54px;
  }

  .zh4{
    margin-bottom: 2px;
    display: block;
    float: right ;
  }
  .card2-legend .spe{
    margin-right: 30px;
  }

  .dialog-title {
    margin-bottom: 30px;
    font-size:18px;
    font-weight: bold;
  }

  .dialog-content {
    font-size:16px;
  }

  .dialog-footer{
    margin:35px auto 0px;
    width:90%;
  }
  .dialog-footer button{
    *background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:3px;
    width:20%;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }

  .dialog-footer .deny {
    float:left;
    background-color:#888;
  }

  .dialog-footer .agree {
    float:right;
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
  }


  @media screen and (max-width: 1300px){
    .legend{
      margin-right:45px;
    }
    .legend-spe1{
      margin-right: 0;
    }
    .card2-legend .legend{
      margin-right: 32px;
    }
    .card2-legend .sep-1{
      margin-right: 10px;
    }
    .card2-legend .sep-2{
      margin-right: 24px;
    }
    .zh1 div{
      margin-right: 50px;
    }
    .zh3 .legend{
      margin-right: 35px;
    }
    .zh3 .sep-2{
      margin-right: 15px;
    }
    .es3 .legend{
      margin-right: 40px;
    }
    .es3 .sep-1{
      margin-right: 77px;
    }
    .es3 .sep-2{
      margin-right: 32px;
    }
    .it1 .legend{
      margin-right: 25px;
    }
    .it2 .sep-1{
      margin-right: 28px;
    }
    .it2 .sep-2{
      margin-right: 32px;
    }
    .po1 .legend{
      margin-right: 30px;
    }
    .po1 .legend-spe1{
      margin-right: 0;
    }
    .po2 .sep-1{
      margin-right: 40px;
    }
    .du1 .legend{
      margin-right: 25px;
    }
    .du1 .legend-spe1{
      margin-right: 0;
    }
    .du2 .legend{
      margin-right: 35px;
    }
  }

</style>



// WEBPACK FOOTER //
// monitor.vue?54cb4ff7